import showAlert from '../alert/alertHandler';
import axios from 'axios';

import showConfirmation from '../confirmation/confirmationHandler';
import cfdiEnUS from '../locales/en-US/cfdi.json';
import cfdiEsCL from '../locales/es-CL/cfdi.json';
import cfdiEsMX from '../locales/es-MX/cfdi.json';
import cfdiEsCO from '../locales/es-CO/cfdi.json';

export default {
  name: 'Cfdi',
  i18n: {
    messages: {
      'en-US': { cfdi: cfdiEnUS },
      'es-CL': { cfdi: cfdiEsCL },
      'es-MX': { cfdi: cfdiEsMX },
      'es-CO': { cfdi: cfdiEsCO },
    },
  },
  data() {
    return {
      imageBussy: false,
      isMainPageBussy: false,
      fileLogo: null,
      urlLogo: null,
      successUploadLogo: false,
      successUploadInfo: false,
      certificate: null,
      privateKey: null,
      privateKeyPassword: null,
      legalName: null,
      rfc: null,
      name: null,
      taxRegime: null,
      postalCode: null,
      dataIssuerValid: {
        legalName: true,
        rfc: true,
        taxRegime: true,
        onlyNumber: true,
        postalCode: true,
        certificate: true,
        extentionCerValid: true,
        privateKey: true,
        extentionKeyValid: true,
        privateKeyPassword: true,
      },
      dataHolderValid: {
        legalName: false,
        rfc: false,
        taxRegime: false,
        postalCode: false,
        certificate: false,
        privateKey: false,
        privateKeyPassword: false,
        cfdiUse: false,
        onlyNumber: false,
        legalNameLength: false,
        rfcLength: false,
        postalCodeLength: false,
      },
      config: null,
      isConfigActive: false,
      cartaPorteEnabled: false,
      imageExtention: null,
      issuerSelected: null,
      currentTab: 'configCfdi',
      holderSelected: [],
      isFilterShown: false,
      isFilterApplied: false,
      isFilterClicked: false,
      formFilter: {
        taxRegime: [],
        cfdiUse: [],
      },
      cfdiUseOptions: [],
      taxRegimeOptions: [],
      filterName: null,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 15, 20, 50, 100],
      currentSortBy: null,
      selectedAllHolders: false,
      holders: [],
      formData: {
        legalName: '',
        rfc: '',
        name: '',
        taxRegime: '',
        cfdiUse: '',
        postalCode: '',
      },
      isEdit: false,
      isLoadingHolderForm: false,
    };
  },
  created() {
    this.prepareData();
  },
  methods: {
    async getCfdiUses() {
      try {

        const response = await axios.get(`${this.$store.getters.urlCartaPorte}/catalogs/CfdiUses`, {
          headers: {
            'id-client': this.$store.getters.clientId,
          },
        });
        if (response.status) {
          return response.data.data;
        }
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    async getTaxRegimens() {
      try {

        const response = await axios.get(`${this.$store.getters.urlCartaPorte}/catalogs/FiscalRegimens`, {
          headers: {
            'id-client': this.$store.getters.clientId,
          },
        });
        if (response.status) {
          return response.data.data;
        }
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    async prepareData() {
      this.isMainPageBussy = true;
      this.dataAccess = this.$store.getters.dataAccess;
      this.config = await this.getConfigClient();
      console.log(this.config);
      if (this.config != null) {
        this.cartaPorteEnabled = this.config.enabledService;
        this.urlLogo = this.config.logoUrl;
        if (this.urlLogo) {
          this.imageExtention = this.urlLogo.slice(-3);
        }
      }
      this.cfdiUseOptions = await this.getCfdiUses();
      this.taxRegimeOptions = await this.getTaxRegimens();
      await this.getIssuerInfo();
      await this.getHolders();
      this.isMainPageBussy = false;
    },
    async getConfigClient() {
      try {
        const response = await axios.get(`${this.$store.getters.urlCartaPorte}/config`, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        if (response.data.status) {
          return response.data.data;
        } else {
          return null;
        }
      } catch (e) {
        console.log(e);
        return null;
      }
    },
    async getIssuerInfo() {
      try {
        const response = await axios.get(`${this.$store.getters.urlCartaPorte}/holder?holderType=issuer`, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        if (response.data.status) {
          const issuer = response.data.data;
          this.populateDataIssuer(issuer[0]);
        }
      } catch (e) {
        console.log(e);
      }
    },
    async createIssuerInfo(body) {
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.post(`${this.$store.getters.urlCartaPorte}/holder`, body, config);
        if (response.data.status) {
          await this.getIssuerInfo();
          return true;
        }
        return false;
      } catch (e) {
        if (e.response && e.response.data) {
          const message = e.response.data.message;
          // Intentar extraer el JSON dentro del mensaje
          const match = message.match(/{.*}/);
          if (match) {
            this.showAlertByFacturama(match, 'create');
            //Trae la data por si fallo las credenciales
            await this.getIssuerInfo();
          } else {
            console.log('Mensaje de error sin JSON:', message);
          }
        } else {
          console.error('Error desconocido:', e + ".");
        }
        return false;
      }
    },
    async updateIssuerInfo(body) {
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.put(
          `${this.$store.getters.urlCartaPorte}/holder/${this.issuerSelected.id}`,
          body,
          config,
        );
        if (response.data.status) {
          await this.getIssuerInfo();
          this.config = await this.getConfigClient();
          return true;
        } else {
          return false;
        }
      } catch (e) {
        if (e.response && e.response.data) {
          const message = e.response.data.message;
          // Intentar extraer el JSON dentro del mensaje
          const match = message.match(/{.*}/);
          if (match) {
            this.showAlertByFacturama(match, 'update');
          } else {
            console.log('Mensaje de error sin JSON:', message);
          }
        } else {
          console.error('Error desconocido:', e + ".");
        }
        return false;
      }
    },
    showAlertByFacturama(match, type) {
      try {
        const jsonData = JSON.parse(match[0]); // Convertir a objeto JSON
        let body = '';
        if (jsonData.ModelState) {
          if (jsonData.ModelState.Certificate) {
            const message = jsonData.ModelState.Certificate[0];
            body = this.buildHtmlMessage(message, type);
          } else if (jsonData.ModelState.Key) {
            const message = jsonData.ModelState.Key[0];
            body = this.buildHtmlMessage(message, type);
          } else {
            const message = jsonData.ModelState.Message;
            body = this.buildHtmlMessage(message, type);
          }
          showAlert(
            this.$t('cfdi.issuer.errorFiles'),
            this.$t('cfdi.issuer.errorBody'),
            'error',
            null,
            null,
            body,
            false,
          );
        }
      } catch (parseError) {
        console.error('Error al parsear el JSON:', parseError);
      }
    },
    buildHtmlMessage(message, type) {
      let body = '';
      const successMesasage =
        type === 'create' ? this.$t('cfdi.issuer.successCreate') : this.$t('cfdi.issuer.successUpdate');
      body = "<div class='m-2 d-flex align-items-start' style='gap: 10px'>";
      body += `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none" style="flex-shrink: 0;">
                <path d="M8.39134 10.9252L6.68926 9.22308C6.54412 9.07794 6.3594 9.00537 6.13509 9.00537C5.91079 9.00537 5.72606 9.07794 5.58092 9.22308C5.43579 9.36822 5.36322 9.55294 5.36322 9.77725C5.36322 10.0016 5.43579 10.1863 5.58092 10.3314L7.83717 12.5877C7.99551 12.746 8.18023 12.8252 8.39134 12.8252C8.60245 12.8252 8.78717 12.746 8.94551 12.5877L13.4184 8.11475C13.5636 7.96961 13.6361 7.78488 13.6361 7.56058C13.6361 7.33627 13.5636 7.15155 13.4184 7.00641C13.2733 6.86127 13.0886 6.7887 12.8643 6.7887C12.64 6.7887 12.4552 6.86127 12.3101 7.00641L8.39134 10.9252ZM9.49967 17.4168C8.40454 17.4168 7.37537 17.209 6.41217 16.7934C5.44898 16.3778 4.61113 15.8137 3.89863 15.1012C3.18613 14.3887 2.62207 13.5509 2.20645 12.5877C1.79082 11.6245 1.58301 10.5953 1.58301 9.50016C1.58301 8.40502 1.79082 7.37586 2.20645 6.41266C2.62207 5.44947 3.18613 4.61162 3.89863 3.89912C4.61113 3.18662 5.44898 2.62256 6.41217 2.20693C7.37537 1.79131 8.40454 1.5835 9.49967 1.5835C10.5948 1.5835 11.624 1.79131 12.5872 2.20693C13.5504 2.62256 14.3882 3.18662 15.1007 3.89912C15.8132 4.61162 16.3773 5.44947 16.7929 6.41266C17.2085 7.37586 17.4163 8.40502 17.4163 9.50016C17.4163 10.5953 17.2085 11.6245 16.7929 12.5877C16.3773 13.5509 15.8132 14.3887 15.1007 15.1012C14.3882 15.8137 13.5504 16.3778 12.5872 16.7934C11.624 17.209 10.5948 17.4168 9.49967 17.4168ZM9.49967 15.8335C11.2677 15.8335 12.7653 15.22 13.9924 13.9929C15.2195 12.7658 15.833 11.2682 15.833 9.50016C15.833 7.73211 15.2195 6.23454 13.9924 5.00745C12.7653 3.78037 11.2677 3.16683 9.49967 3.16683C7.73162 3.16683 6.23405 3.78037 5.00697 5.00745C3.77988 6.23454 3.16634 7.73211 3.16634 9.50016C3.16634 11.2682 3.77988 12.7658 5.00697 13.9929C6.23405 15.22 7.73162 15.8335 9.49967 15.8335Z" fill="#14B823"/>
              </svg>`;
      body +=
        '<label style="font-size: 0.875rem;; white-space: normal; word-break: break-word;">' +
        successMesasage +
        '</label>';
      body += '</div>';
      body += "<div class='m-2 d-flex align-items-start' style='gap: 10px'>";
      body += `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none" style="flex-shrink: 0;">
                <path d="M9.49968 10.6085L11.7955 12.9043C11.9406 13.0495 12.1254 13.122 12.3497 13.122C12.574 13.122 12.7587 13.0495 12.9038 12.9043C13.049 12.7592 13.1216 12.5745 13.1216 12.3502C13.1216 12.1259 13.049 11.9411 12.9038 11.796L10.608 9.50016L12.9038 7.20433C13.049 7.05919 13.1216 6.87447 13.1216 6.65016C13.1216 6.42586 13.049 6.24114 12.9038 6.096C12.7587 5.95086 12.574 5.87829 12.3497 5.87829C12.1254 5.87829 11.9406 5.95086 11.7955 6.096L9.49968 8.39183L7.20384 6.096C7.0587 5.95086 6.87398 5.87829 6.64967 5.87829C6.42537 5.87829 6.24065 5.95086 6.09551 6.096C5.95037 6.24114 5.8778 6.42586 5.8778 6.65016C5.8778 6.87447 5.95037 7.05919 6.09551 7.20433L8.39134 9.50016L6.09551 11.796C5.95037 11.9411 5.8778 12.1259 5.8778 12.3502C5.8778 12.5745 5.95037 12.7592 6.09551 12.9043C6.24065 13.0495 6.42537 13.122 6.64967 13.122C6.87398 13.122 7.0587 13.0495 7.20384 12.9043L9.49968 10.6085ZM9.49968 17.4168C8.40454 17.4168 7.37537 17.209 6.41217 16.7934C5.44898 16.3778 4.61113 15.8137 3.89863 15.1012C3.18613 14.3887 2.62207 13.5509 2.20645 12.5877C1.79082 11.6245 1.58301 10.5953 1.58301 9.50016C1.58301 8.40502 1.79082 7.37586 2.20645 6.41266C2.62207 5.44947 3.18613 4.61162 3.89863 3.89912C4.61113 3.18662 5.44898 2.62256 6.41217 2.20693C7.37537 1.79131 8.40454 1.5835 9.49968 1.5835C10.5948 1.5835 11.624 1.79131 12.5872 2.20693C13.5504 2.62256 14.3882 3.18662 15.1007 3.89912C15.8132 4.61162 16.3773 5.44947 16.7929 6.41266C17.2085 7.37586 17.4163 8.40502 17.4163 9.50016C17.4163 10.5953 17.2085 11.6245 16.7929 12.5877C16.3773 13.5509 15.8132 14.3887 15.1007 15.1012C14.3882 15.8137 13.5504 16.3778 12.5872 16.7934C11.624 17.209 10.5948 17.4168 9.49968 17.4168ZM9.49968 15.8335C11.2677 15.8335 12.7653 15.22 13.9924 13.9929C15.2195 12.7658 15.833 11.2682 15.833 9.50016C15.833 7.73211 15.2195 6.23454 13.9924 5.00745C12.7653 3.78037 11.2677 3.16683 9.49968 3.16683C7.73162 3.16683 6.23405 3.78037 5.00697 5.00745C3.77988 6.23454 3.16634 7.73211 3.16634 9.50016C3.16634 11.2682 3.77988 12.7658 5.00697 13.9929C6.23405 15.22 7.73162 15.8335 9.49968 15.8335Z" fill="#F04438"/>
              </svg>`;
      body +=
        '<label style="font-size: 0.875rem;; white-space: normal; word-break: break-word;">' + message + '</label>';
      body += '</div>';

      return body;
    },
    getActualStamps(){
      if(this.config){
        return this.config.totalStamps - this.config.actualStamps;
      }
      return 0;
    },
    populateDataIssuer(issuer) {
      this.issuerSelected = issuer;
      if (issuer.Rfc) {
        this.rfc = issuer.Rfc;
      }
      if (issuer.LegalName) {
        this.legalName = issuer.LegalName;
      }
      if (issuer.RegimenFiscal) {
        const taxRegim = this.taxRegimeOptions.find((regime) => regime.Value === issuer.RegimenFiscal);
        this.taxRegime = taxRegim;
      }
      if (issuer.PostalCode !== null && issuer.PostalCode !== '') {
        this.postalCode = issuer.PostalCode;
      }
      if (issuer.Certificate) {
        this.certificate = issuer.Certificate;
      }
      if (issuer.PrivateKey) {
        this.privateKey = issuer.PrivateKey;
      }
      if (issuer.PrivateKeyPassword) {
        this.privateKeyPassword = issuer.PrivateKeyPassword;
      }
      if (issuer.Name) {
        this.name = issuer.Name;
      }
      if (this.certificate && this.privateKey && this.privateKeyPassword) {
        this.isConfigActive = true;
      }
    },
    handleManageCartaPorte(event) {
      const newValue = event.target.checked;
      //Dependiendo si quiero activar o desactivar el servicio carta porte, mi mensaje de confirmacion cambia
      if (newValue) {
        showConfirmation(
          this.$t('cfdi.issuer.modal.title'),
          this.$t('cfdi.issuer.modal.body'),
          async () => {
            await this.handleService(newValue);
          },
          this.$t('common.cruds.aceptar'),
          this.$t('common.cruds.cerrar'),
          async () => {
            this.cartaPorteEnabled = !newValue;
          },
        );
      } else {
        showConfirmation(
          this.$t('cfdi.issuer.modal.titleDeactive'),
          this.$t('cfdi.issuer.modal.bodyDeactive'),
          async () => {
            await this.handleService(newValue);
          },
          this.$t('common.cruds.aceptar'),
          this.$t('common.cruds.cerrar'),
          async () => {
            this.cartaPorteEnabled = !newValue;
          },
        );
      }
    },
    async saveLogoConfig(urlLogo) {
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const body = {
          logoUrl: urlLogo,
        };
        const response = await axios.post(`${this.$store.getters.urlCartaPorte}/config/logo`, body, config);
        if (response.data.status) {
          return true;
        }
        return false;
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    async handleService(enabled) {
      this.cartaPorteEnabled = enabled;
      this.isMainPageBussy = true;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const body = {
          EnabledService: enabled,
        };
        const response = await axios.put(`${this.$store.getters.urlCartaPorte}/config/handle-service`, body, config);
        if (response.data.status) {
          this.isMainPageBussy = false;
        }
      } catch (e) {
        console.log(e);
        this.isMainPageBussy = false;
      }
    },
    addCertificate(event) {
      const file = event.target.files[0];

      if (file && !file.name.toLowerCase().endsWith('.cer')) {
        this.showPopover('certificate');
        this.dataIssuerValid.extentionCerValid = false;
        event.target.value = null;
        return;
      }
      this.hidePopover('certificate');
      this.dataIssuerValid.extentionCerValid = true;

      if (file) {
        const reader = new FileReader();

        reader.onload = () => {
          this.certificate = reader.result.split(',')[1]; // Guardamos el Base64 en la variable
        };

        reader.onerror = () => {
          console.error('Error al leer el archivo.');
        };

        reader.readAsDataURL(file);
      }
    },
    addPrivateKey(event) {
      const file = event.target.files[0];

      if (file && !file.name.toLowerCase().endsWith('.key')) {
        this.dataIssuerValid.extentionKeyValid = false;
        this.showPopover('privateKey');
        event.target.value = null;
        return;
      }
      this.hidePopover('privateKey');
      this.dataIssuerValid.extentionKeyValid = true;
      if (file) {
        const reader = new FileReader();

        reader.onload = () => {
          this.privateKey = reader.result.split(',')[1]; // Guardamos el Base64 en la variable
        };

        reader.onerror = () => {
          console.error('Error al leer el archivo.');
        };

        reader.readAsDataURL(file);
      }
    },
    deleteCertificate() {
      if (this.certificate) {
        this.certificate = null;
        if (this.$refs.certificate) {
          this.$refs.certificate.value = '';
        }
      }
    },
    deletePrivateKey() {
      if (this.privateKey) {
        this.privateKey = null;
        if (this.$refs.privateKey) {
          this.$refs.privateKey.value = '';
        }
      }
    },
    deletePrivateKeyPassword() {
      if (this.privateKeyPassword) {
        this.privateKeyPassword = null;
      }
    },
    deleteLogo() {
      if (this.urlLogo) {
        this.urlLogo = null; 
        if (this.$refs.urlLogo) {
          this.$refs.logo_file.value = '';
        }
      }
    },
    async addLogoPicture(event) {
      this.imageBussy = true;
      let file = event.target.files[0];
      if (file && !file.name.toLowerCase().endsWith('.jpg') && !file.name.toLowerCase().endsWith('.png')) {
        this.fileLogo = null;
        event.target.value = null;
        return;
      }
      const maxSize = 1 * 1024 * 1024; // 1MB en bytes;
      if (file && file.size > maxSize) {
        this.fileLogo = null;
        showAlert('Error', this.$t('cfdi.limitSize') + ".");
        this.imageBussy = false;
        return;
      }
      const file64 = await this.readFileAsync(file);
      this.fileLogo = file64.split(',')[1];
      this.imageBussy = false;
    },
    readFileAsync(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.onerror = reject;
      });
    },
    async saveImage() {
      if (this.fileLogo) {
        this.imageBussy = true;
        await this.uploadImageS3(this.fileLogo);
        this.imageBussy = false;
      } else {
        this.successUploadLogo = await this.saveLogoConfig(this.urlLogo);
      }
    },
    async uploadImageS3(fileBase64) {
      let date = new Date(this.$store.getters.dateToken);
      let now = new Date();
      let diff = Math.floor(Math.abs(now - date) / 1000 / 60);
      let rt = this.$store.getters.refreshToken;
      let firstTime = this.$store.getters.firstTimeRefresh;
      console.log(diff);
      if (firstTime || (diff >= 15 && rt)) {
        try {
          showAlert('Información', this.$t('common.waitingForToken'));
          console.log('Obteniendo el nuevo Token');
          const url = `${this.$store.getters.urlSimpleLogin}/refreshToken`;
          const body = {
            refreshToken: rt,
          };
          const response = await axios.post(url, body);
          console.log(response.data.AccessToken);
          this.$store.commit('saveFirstTimeRefresh', false);
          this.$store.commit('saveAccessToken', response.data.AccessToken);
          this.$store.commit('saveDateToken', now);
        } catch (e) {
          console.log(e);
        }
      }
      const url = `${this.$store.getters.urlImage}/simpleimageuploader/upload?project=lastmile&isBase64=true`;
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      const body = {
        image: fileBase64,
      };
      try {
        const response = await axios.post(url, body, config);
        this.urlLogo = response.data.url;
        if (this.urlLogo) {
          this.imageExtention = this.urlLogo.slice(-3);
        }
        this.successUploadLogo = await this.saveLogoConfig(this.urlLogo);
      } catch (e) {
        showAlert('Error', e.response.data + ".");
      }
    },
    async changeTab(navBar) {
      this.currentTab = navBar;
    },
    async saveConfig() {
      this.isMainPageBussy = true;
      if (this.validateCredentials() && this.validateIssuer()) {
        const body = this.buildBody();
        if (this.issuerSelected) {
          this.successUploadInfo = await this.updateIssuerInfo(body);
        } else {
          this.successUploadInfo = await this.createIssuerInfo(body);
        }
      }
      this.isMainPageBussy = false;
    },
    buildBody() {
      let body = {
        Type: 'issuer',
        LegalName: this.legalName,
        RegimenFiscal: this.taxRegime.Value,
        PostalCode: this.postalCode,
        Rfc: this.rfc,
      };
      if (this.name) {
        body = {
          ...body,
          Name: this.name,
        };
      }
      if (this.certificate) {
        body = {
          ...body,
          Certificate: this.certificate,
        };
      }
      if (this.privateKey) {
        body = {
          ...body,
          PrivateKey: this.privateKey,
        };
      }
      if (this.privateKeyPassword) {
        body = {
          ...body,
          PrivateKeyPassword: this.privateKeyPassword,
        };
      }
      return body;
    },
    validateCredentials() {
      const validPrivateKey = this.privateKey && this.privateKey !== '';
      const validPrivateKeyPassword = this.privateKeyPassword && this.privateKeyPassword !== '';
      const validcertificate = this.certificate && this.certificate !== '';
      if (validPrivateKey && validPrivateKeyPassword && validcertificate) {
        this.isConfigActive = true;
      } else {
        this.isConfigActive = false;
      }
      //Si falta algun documento, o si no existe un issuer, entonces debo validar que ingrese todos los datos
      if (validPrivateKey || validPrivateKeyPassword || validcertificate || !this.issuerSelected) {
        if (validPrivateKey) {
          this.dataIssuerValid.privateKey = true;
          this.hidePopover('privateKey');
        } else {
          this.dataIssuerValid.privateKey = false;
          this.showPopover('privateKey');
        }
        if (validPrivateKeyPassword) {
          this.dataIssuerValid.privateKeyPassword = true;
          this.hidePopover('privateKeyPassword');
        } else {
          this.dataIssuerValid.privateKeyPassword = false;
          this.showPopover('privateKeyPassword');
        }
        if (validcertificate) {
          this.dataIssuerValid.certificate = true;
          this.hidePopover('certificate');
        } else {
          this.dataIssuerValid.certificate = false;
          this.showPopover('certificate');
        }
        return validPrivateKey && validPrivateKeyPassword && validcertificate;
      } else {
        this.dataIssuerValid.privateKeyPassword = true;
        this.dataIssuerValid.privateKey = true;
        this.dataIssuerValid.certificate = true;
        this.hidePopover('certificate');
        this.hidePopover('privateKey');
        this.hidePopover('privateKeyPassword');
        return true;
      }
    },
    validateIssuer() {
      const validRfc = this.validateRfc();
      const validLegalName = this.validateLegalName();
      const validTaxRegime = this.validateTaxRegime();
      const validPostalCode = this.validatePostalCode();
      return validRfc && validLegalName && validTaxRegime && validPostalCode;
    },
    validateRfc() {
      if (this.rfc && this.rfc !== '') {
        this.hidePopover('rfc');
        this.dataIssuerValid.rfc = true;
        return true;
      }
      this.dataIssuerValid.rfc = false;
      this.showPopover('rfc');
      return false;
    },
    validateLegalName() {
      if (this.legalName && this.legalName !== '') {
        this.hidePopover('legalName');
        this.dataIssuerValid.legalName = true;
        return true;
      }
      this.dataIssuerValid.legalName = false;
      this.showPopover('legalName');
      return false;
    },
    validateTaxRegime() {
      if (this.taxRegime && this.taxRegime.Value) {
        this.hidePopover('taxRegime');
        this.dataIssuerValid.taxRegime = true;
        return true;
      }
      this.dataIssuerValid.taxRegime = false;
      this.showPopover('taxRegime');
      return false;
    },
    validatePostalCode() {
      let valid = true;
      if (this.postalCode && this.postalCode !== '') {
        this.dataIssuerValid.postalCode = true;
        valid = true;
      } else {
        this.dataIssuerValid.postalCode = false;
        valid = false;
      }
      if (this.isOnlyNumbers(this.postalCode)) {
        this.dataIssuerValid.onlyNumber = true;
        valid = true;
      } else {
        this.dataIssuerValid.onlyNumber = false;
        valid = false;
      }
      if (!valid) {
        this.showPopover('postalCode');
      }
      return valid;
    },
    isOnlyNumbers(str) {
      return /^\d+$/.test(str);
    },
    showPopover(id) {
      const wrongClass = 'form-control-warning';
      const multiselect = document.querySelector(`#${id}`);
      if (multiselect) {
        multiselect.classList.add(wrongClass);
        return;
      }
      if (document.getElementById(id)) {
        document.getElementById(id).classList.add(wrongClass);
      }
    },
    hidePopover(id) {
      const wrongClass = 'form-control-warning';
      const multiselect = document.querySelector(`#${id}`);
      if (multiselect) {
        multiselect.classList.remove(wrongClass);
        return;
      }
    },
    async getHolders() {
      this.holders = [];
      try {
        const url = `${this.$store.getters.urlCartaPorte}/holder?holderType=receiver`;
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.get(url, config);
        response.data.data.forEach((holderTemp) => {
          this.holders.push({
            Id: holderTemp.id,
            LegalName: holderTemp.LegalName,
            Rfc: holderTemp.Rfc,
            Name: holderTemp.Name,
            RegimenFiscal: this.taxRegimeOptions.find((regime) => regime.Value === holderTemp.RegimenFiscal).Name,
            CfdiUse: this.cfdiUseOptions.find((cfdiUse) => cfdiUse.Value === holderTemp.CfdiUse).Name,
            PostalCode: holderTemp.PostalCode,
          });
        });
        console.log(response);
      } catch (e) {
        console.log(e);
      }
    },
    async newReceiver() {
      try {
        const url = `${this.$store.getters.urlCartaPorte}/holder`;
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        let body = {
          Type: 'receiver',
          LegalName: this.formData.legalName,
          Name: this.formData.name,
          CfdiUse: this.formData.cfdiUse.Value,
          RegimenFiscal: this.formData.taxRegime.Value,
          PostalCode: this.formData.postalCode,
          Rfc: this.formData.rfc,
        };

        this.isMainPageBussy = true;
        await axios.post(url, body, config);
        await this.getHolders();
        this.cancelForm('cfdi-form');
        showAlert('Éxito', this.$t('cfdi.success.createReceiver') + ".");
        this.isMainPageBussy = false;
        this.isLoadingHolderForm = false;
      } catch (e) {
        console.log(e);
        showAlert('Error', e.response?.data?.message + "." || 'Ocurrió un error inesperado.');
        this.isLoadingHolderForm = false;
        await this.getHolders();
        //this.cancelForm('cfdi-form');
        this.isMainPageBussy = false;
      }
    },
    async editReceiver() {
      try {
        const url = `${this.$store.getters.urlCartaPorte}/holder/${this.formData.id}`;
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        let body = {
          Id: this.formData.id,
          Type: 'receiver',
          LegalName: this.formData.legalName,
          Name: this.formData.name,
          CfdiUse: this.formData.cfdiUse.Value,
          RegimenFiscal: this.formData.taxRegime.Value,
          PostalCode: this.formData.postalCode,
          Rfc: this.formData.rfc,
        };

        this.isMainPageBussy = true;
        await axios.put(url, body, config);
        await this.getHolders();
        this.cancelForm('cfdi-form');
        showAlert('Éxito', this.$t('cfdi.success.editReceiver') + ".");
        this.isMainPageBussy = false;
        this.isLoadingHolderForm = false;
      } catch (e) {
        console.log(e);
        showAlert('Error', e.response?.data?.message + "." || 'Ocurrió un error inesperado.');
        this.isLoadingHolderForm = false;
        await this.getHolders();
        //this.cancelForm('cfdi-form');
        this.isMainPageBussy = false;
      }
    },
    submitForm() {
      if (this.validateHolderForm()) {
        // Handle form submission
        console.log('Form submitted', this.formData);
        this.isLoadingHolderForm = true;
        if (!this.isEdit) {
          this.newReceiver();
        } else {
          this.editReceiver();
        }
      }
    },
    cancelForm(id) {
      // Handle form cancellation
      console.log('Form cancelled');
      this.hideModal(id);
    },
    validateHolderForm() {
      let isValid = true;
      if (this.formData.legalName === '') {
        this.dataHolderValid.legalName = true;
        this.showPopover('legalNameHolder');
        isValid = false;
      } else {
        this.dataHolderValid.legalName = false;
      }
      if (this.formData.rfc === '') {
        this.dataHolderValid.rfc = true;
        this.showPopover('rfcHolder');
        isValid = false;
      } else {
        this.dataHolderValid.rfc = false;
      }
      if (this.formData.taxRegime === '' || this.formData.taxRegime === null) {
        this.dataHolderValid.taxRegime = true;
        this.showPopover('taxRegimeHolder');
        isValid = false;
      } else {
        this.dataHolderValid.taxRegime = false;
      }
      if (this.formData.cfdiUse === '' || this.formData.cfdiUse === null) {
        this.dataHolderValid.cfdiUse = true;
        this.showPopover('cfdiUseHolder');
        isValid = false;
      } else {
        this.dataHolderValid.cfdiUse = false;
      }
      if (this.formData.postalCode === '' || this.formData.postalCode === null) {
        this.dataHolderValid.postalCode = true;
        this.showPopover('postalCodeHolder');
        isValid = false;
      } else {
        this.dataHolderValid.postalCode = false;
      }
      if (!/^[0-9]+$/.test(this.formData.postalCode)) {
        this.dataHolderValid.onlyNumber = true;
        isValid = false;
      } else {
        this.dataHolderValid.onlyNumber = false;
      }

      if (this.formData.legalName.length > 30) {
        this.showPopover('legalNameHolder');
        this.dataHolderValid.legalNameLength = true;
        isValid = false;
      } else {
        this.dataHolderValid.legalNameLength = false;
      }

      if (this.formData.rfc.length > 15) {
        this.showPopover('rfcHolder');
        this.dataHolderValid.rfcLength = true;
        isValid = false;
      } else {
        this.dataHolderValid.rfcLength = false;
      }

      if (this.formData.postalCode.length > 8) {
        this.showPopover('postalCodeHolder');
        this.dataHolderValid.postalCodeLength = true;
        isValid = false;
      } else {
        this.dataHolderValid.postalCodeLength = false;
      }
      return isValid;
    },
    activeFilter() {
      this.isFilterShown = !this.isFilterShown;
      this.isFilterClicked = !this.isFilterClicked;
    },
    cleanFilter() {
      this.currentSortBy = null;
      this.formFilter = {
        taxRegime: [],
        cfdiUse: [],
      };
    },
    checkHolders() {
      if (this.selectedAllHolders) {
        this.checkAllHolders();
      } else {
        this.unCheckAllHolders();
      }
    },
    checkAllHolders() {
      this.holderSelected = [];
      for (const holder of this.filtered) {
        this.holderSelected.push(holder.Id);
      }
    },
    unCheckAllHolders() {
      this.holderSelected = [];
    },
    limitText(count) {
      return this.$t('cfdi.limitText') + (count + 1);
    },
    createHoldeFormData(id) {
      this.isEdit = false;
      this.clearFormData();
      this.$bvModal.show(id);
    },
    editHoldeFormData(data) {
      this.isEdit = true;
      this.clearFormData();
      this.loadFormData(data);
      this.$bvModal.show('cfdi-form');
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    hideModal(id) {
      this.$bvModal.hide(id);
    },
    async deleteMassiveConfirmation() {
      showConfirmation(
        this.$t('common.modals.confirmacionTitulo'),
        this.$t('cfdi.confirmation.deleteMassive'),
        () => {
          this.deleteMassive();
        },
        this.$t('common.cruds.aceptar'),
        this.$t('common.cruds.cerrar'),
      );
    },
    async deleteMassive() {
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        this.isMainPageBussy = true;
        await axios.post(`${this.$store.getters.urlCartaPorte}/holder/delete-by-ids`, this.holderSelected, config);
        this.holderSelected = [];
        await this.getHolders();
        showAlert('Éxito', this.$t('cfdi.success.deleteMassive') + ".");
        this.isMainPageBussy = false;
        return false;
      } catch (e) {
        console.log(e);
        showAlert('Error', e.response?.data?.message + "." || 'Ocurrió un error inesperado.');
        await this.getHolders();
        this.isMainPageBussy = false;
        return false;
      }
    },
    enabledHandlerConfig() {
      const validPrivateKey = this.privateKey && this.privateKey !== '';
      const validPrivateKeyPassword = this.privateKeyPassword && this.privateKeyPassword !== '';
      const validcertificate = this.certificate && this.certificate !== '';
      return validPrivateKey && validPrivateKeyPassword && validcertificate;
    },
    async deleteHolderConfirmation(data) {
      showConfirmation(
        this.$t('common.modals.confirmacionTitulo'),
        this.$t('cfdi.confirmation.deleteHolder'),
        () => {
          this.deleteHolder(data);
        },
        this.$t('common.cruds.aceptar'),
        this.$t('common.cruds.cerrar'),
      );
    },
    async deleteHolder(data) {
      console.log(data);
      try {
        this.isMainPageBussy = true;
        await axios.delete(`${this.$store.getters.urlCartaPorte}/holder/` + data.Id, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        await this.getHolders();
        showAlert('Éxito', this.$t('cfdi.success.delete') + ".");
        this.isMainPageBussy = false;
      } catch (e) {
        console.log(e);
        showAlert('Error', e.response?.data?.message + "." || 'Ocurrió un error inesperado.');
        await this.getHolders();
        this.isMainPageBussy = false;
      }
    },
    loadFormData(data) {
      this.formData = {
        id: data.Id,
        legalName: data.LegalName,
        rfc: data.Rfc,
        name: data.Name,
        taxRegime: this.taxRegimeOptions.find((regime) => regime.Name === data.RegimenFiscal),
        cfdiUse: this.cfdiUseOptions.find((cfdiUse) => cfdiUse.Name === data.CfdiUse),
        postalCode: data.PostalCode,
      };
    },
    clearFormData() {
      this.formData = {
        legalName: '',
        rfc: '',
        name: '',
        taxRegime: '',
        cfdiUse: '',
        postalCode: '',
      };

      this.dataHolderValid = {
        legalName: false,
        rfc: false,
        taxRegime: false,
        postalCode: false,
        certificate: false,
        privateKey: false,
        privateKeyPassword: false,
        cfdiUse: false,
        onlyNumber: false,
        legalNameLength: false,
        rfcLength: false,
        postalCodeLength: false,
      }
    },
    toogleFilter() {
      if (this.isFilterShown && !this.isFilterClicked) {
        this.isFilterShown = false;
      }
      if (this.isFilterClicked) {
        this.isFilterClicked = false;
      }
    },
    activeCfdiFilter() {
      this.isFilterClicked = true;
    },
  },
  computed: {
    holderFields() {
      const common = {
        class: 'text-left',
        tdClass: 'small',
      };
      return [
        {
          key: 'select',
          label: '',
          ...common,
        },
        {
          key: 'LegalName',
          label: this.$t('cfdi.table.legalName'),
          sortable: true,
          ...common,
        },
        {
          key: 'Rfc',
          label: this.$t('cfdi.table.rfc'),
          sortable: true,
          ...common,
        },
        {
          key: 'Name',
          label: this.$t('cfdi.table.name'),
          sortable: true,
          ...common,
        },
        {
          key: 'RegimenFiscal',
          label: this.$t('cfdi.table.taxRegime'),
          sortable: true,
          ...common,
        },
        {
          key: 'CfdiUse',
          label: this.$t('cfdi.table.cfdiUse'),
          sortable: true,
          ...common,
        },
        {
          key: 'PostalCode',
          label: this.$t('cfdi.table.postalCode'),
          sortable: true,
          ...common,
        },
        {
          key: 'actions',
          label: this.$t('cfdi.table.actions'),
          class: 'text-center',
        },
      ];
    },
    filtered() {
      let auxHolders = this.holders;
      console.log(auxHolders);
      console.log(this.filterName);
      let filterApplied = false;
      if (this.filterName) {
        auxHolders = auxHolders.filter(
          (holder) =>
            holder.LegalName.toUpperCase().includes(this.filterName.toUpperCase()) ||
            holder.Rfc.toUpperCase().includes(this.filterName.toUpperCase()) ||
            holder.Name.toUpperCase().includes(this.filterName.toUpperCase()) ||
            holder.PostalCode.toUpperCase().includes(this.filterName.toUpperCase()),
        );
      }

      if (this.formFilter.taxRegime && this.formFilter.taxRegime.length > 0) {
        auxHolders = auxHolders.filter((holder) => {
          return this.formFilter.taxRegime.some((taxRegimeTemp) => {
            console.log('taxRegimeTemp');
            console.log(taxRegimeTemp);
            console.log('holder');
            console.log(holder);
            return taxRegimeTemp.Name === holder.RegimenFiscal;
          });
        });
        filterApplied = true;
      }
      if (this.formFilter.cfdiUse && this.formFilter.cfdiUse.length > 0) {
        auxHolders = auxHolders.filter((holder) => {
          return this.formFilter.cfdiUse.some((cfdiUseTemp) => {
            console.log('cfdiUseTemp');
            console.log(cfdiUseTemp);
            console.log('holder');
            console.log(holder);
            return cfdiUseTemp.Name === holder.CfdiUse;
          });
        });
        filterApplied = true;
      }

      this.isFilterApplied = filterApplied;
      return auxHolders;
    },
  },
  watch: {},
};
